import React, { useEffect, useState } from "react";
import { PriceExpander } from "./index";
import { Button } from "../../components/Button";
import { BsTrashFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import content from "../../content";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentProject } from "../../reducers/project/selectors";
import addProjectToCart from "../../actions/project/addProjectToCart";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useFetch } from "../../hooks/useFetch";
import { IProject } from "../../reducers/project";
import AlertDialog from "../Dialog/Dialog";
import {Box} from "@material-ui/core";

function PriceExpanderMobile({}: IPriceExpanderMobile) {
  const [openDialog, setOpenDialog] = useState(false);
  const openResetDialog = () => setOpenDialog(true);
  const dispatch = useDispatch();
  const project = useSelector(getCurrentProject);

  const reset = () => dispatch({ type: ProjectActions.Reset });

  const [responseNew, requestNew] = useFetch<IProject>("/project/");
  const [responseUpdate, requestUpdate] = useFetch<IProject>(
    "/project/",
    {} as any,
    {
      method: "PUT",
    }
  );

  useEffect(() => {
    if (project.components.length !== 0 && project.components.every(Boolean)) {
      if (project.id) {
        requestUpdate(project, project.id).then((data) => {
          dispatch({
            type: ProjectActions.UpdateHistory,
            project: data,
          });
        });
      } else {
        requestNew(project).then((data) => {
          dispatch({
            type: ProjectActions.UpdateHistory,
            project: data,
          });
        });
      }
    }
  }, [project]);

  const addProject = () => {
    dispatch(addProjectToCart(project));
    dispatch(reset());
  };

  return (
    <div style={{ position:'absolute', bottom: 0, backgroundColor: 'white', width: "100%" }}>
        <AlertDialog
            handleClose={() => setOpenDialog(false)}
            title={content.getValue("notification_header_reset")}
            action={reset}
            label={content.getValue("notification_info_reset")}
            open={openDialog}
        />
      <PriceExpander />
      <div style={{ display: "flex", width: "100%" }}>
        <Button
          onClick={openResetDialog}
          disabled={!project.id}
          style={{
            width: "10%",
            marginRight: "30%",
            borderRadius: 0,
            height: "45px",
          }}
          Icon={
            <BsTrashFill
              size={"18px"}
              style={{
                position: "absolute",
                left: "35%",
              }}
            />
          }
          label={""}
          variant={"text"}
          color={"secondary"}
        />
        <Link
          style={{
            width: "100%",
            pointerEvents: !project.id ? "none" : "all",
          }}
          to={"/cart"}
        >
          <Button
            color={"secondary"}
            onClick={addProject}
            variant={"outlined"}
            disabled={!project.id}
            Icon={
              <svg
                style={{
                  position: "absolute",
                  right: "20px",
                }}
                width="17"
                height="8"
                viewBox="0 0 17 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                  fill={!project.id ? "rgba(0, 0, 0, 0.26)" : "#C41230"}
                />
              </svg>
            }
            label={content.getValue("button_go_to_cart")}
          />
        </Link>
      </div>
    </div>
  );
}

export interface IPriceExpanderMobile {}

export default PriceExpanderMobile;
